module.exports = __webpack_public_path__ + "static/media/3.Cutting-Machines.4634a4cb.webp";